import { AutoMap } from "@automapper/classes";
import { AreaMapDTO } from "./area-map.dto";
import { ProcessMeasureDTO } from "./process-measure.dto";

export class ProcessDTO {

    @AutoMap()
    code!: string;
    @AutoMap()
    name!: string;
    @AutoMap()
    customerReference?: string;
    @AutoMap()
    type!: number;
    @AutoMap()
    dustLevel!: string;
    @AutoMap()
    dustLoadType!: string;
    @AutoMap()
    subSection!: number;
    @AutoMap()
    observation?: string;
    @AutoMap()
    ventilationGlobale!: number;
    @AutoMap()
    processMesure: ProcessMeasureDTO = new ProcessMeasureDTO();
    @AutoMap()
    areaMap: AreaMapDTO = new AreaMapDTO();
}
